import Vue from 'vue'
import Vuex, { Module } from 'vuex'
import DemoConfigModel from '@/models/DemoConfigModel'
import { notification } from 'ant-design-vue'

Vue.use(Vuex)

export const demoConfigStore: Module<any, any> = {
  state: {
    demoConfigList: {
      data: [],
      meta: {
        per_page: 25,
        total: 0
      }
    },
    currentDemoConfig: {
      modular_total: 0,
      carcass_total: 0,
      completion_total: 0,
      extra_total: 0,
      total: 0,
      building_id: null,
      building: {
        reference: '',
        number: null,
        price: 0,
        project: {
          reference: '',
          name: ''
        },
        received_orders: {
          modular: {
            received: false
          },
          carcass: {
            received: false
          },
          completion: {
            received: false
          },
          extra: {
            received: false
          }
        }
      },
      customer_id: null,
      customer: {
        reference: ''
      }
    },
    loading: {
      list: false,
      item: false,
      save: false
    },
    errors: {}
  },
  mutations: {
    setCurrentDemoConfig (state, { currentDemoConfig }) {
      state.currentDemoConfig = currentDemoConfig
    },
    clearCurrentDemoConfig (state) {
      state.currentDemoConfig = {
        modular_total: 0,
        carcass_total: 0,
        completion_total: 0,
        extra_total: 0,
        total: 0,
        project_id: null,
        project: {
          reference: '',
          name: ''
        },
        building_id: null,
        building: {
          reference: '',
          number: null,
          price: 0,
          received_orders: {
            modular: {
              received: false
            },
            carcass: {
              received: false
            },
            completion: {
              received: false
            },
            extra: {
              received: false
            }
          }
        },
        customer_id: null,
        customer: {
          reference: ''
        }
      }
    },
    setDemoConfigList (state, { demoConfigList }) {
      state.demoConfigList = demoConfigList
    },
    setLoading (state, data) {
      state.loading[data.type] = data.state
    }
  },
  actions: {
    getDemoConfigList ({ commit }, data) {
      commit('setLoading', { type: 'list', state: true })
      let demoConfigModel = new DemoConfigModel()

      // Add filters if there are any filters set.
      if (data.activeFilters) {
        Object.keys(data.activeFilters).forEach(key => {
          if (data.activeFilters[key].length) {
            demoConfigModel = demoConfigModel.whereIn(key, data.activeFilters[key])
          }
        })
      }

      // Add search if available.
      if (data.search) {
        demoConfigModel = demoConfigModel.where('search', data.search)
      }

      // Add orderBy if sort is set.
      if (data.sort) {
        demoConfigModel = demoConfigModel.orderBy(data.sort.order === 'ascend' ? data.sort.columnKey : '-' + data.sort.columnKey)
      }

      if (data.pagination) {
        demoConfigModel = demoConfigModel.limit(data.pagination.pageSize).page(data.pagination.current)
      }

      demoConfigModel.get().then((demoConfigList) => {
        commit('setDemoConfigList', { demoConfigList })
      }).catch(() => {
        notification.error({ message: 'Fout tijdens het ophalen van de demo configuraties!', description: 'Er is iets mis gegaan. Probeer het later nog een keer.', duration: 3 })
      }).finally(() => {
        commit('setLoading', { type: 'list', state: false })
      })
    },
    setCurrentDemoConfig ({ commit }, id) {
      commit('setErrors', {})
      return new Promise((resolve, reject) => {
        commit('setLoading', { type: 'item', state: true })
        DemoConfigModel.$find(id).then((currentDemoConfig) => {
          commit('setCurrentDemoConfig', { currentDemoConfig })
          resolve(currentDemoConfig)
        }).catch((e) => {
          notification.error({
            message: 'Fout tijdens het ophalen van deze demo configuratie!',
            description: 'Er is iets mis gegaan. Probeer het later nog een keer.',
            duration: 3
          })
          reject(e)
        }).finally(() => {
          commit('setLoading', { type: 'item', state: false })
        })
      })
    },
    clearCurrentDemoConfig ({ commit }) {
      commit('clearCurrentDemoConfig')
    }
  },
  getters: {
    demoConfigList: state => state.demoConfigList,
    currentDemoConfig: state => state.currentDemoConfig,
    loadingDemoConfig: state => state.loading
  }
}
